module.exports = __webpack_public_path__ + "r-v3/img/ml_06_00.9a3bbed7.jpg";